/* eslint-disable jsx-a11y/anchor-is-valid */
// eslint-disable-next-line jsx-a11y/anchor-is-valid
import React, { useContext } from 'react';
import { Image, Row, Col } from '@thd-olt-component-react/core-ui';
import { getImageURL, getHostCURL } from '../../../common/utils/cardUtils';
import { handleFooterAnalytics } from '../../../common/utils/AnalyticsUtils';
import * as Constants from '../../../core/Constants';
import { DataContext } from '../../../contexts';
import './ProXtraLinks.scss';

const analytics = Constants.analytics.FOOTER;

const PerksLink = () => (
  <a
    href={getHostCURL('/b2b/account/view/proXtraPerks')}
    rel=" noreferrer"
    onClick={() => handleFooterAnalytics(analytics.PREFIX, analytics.Perks)}
  >
    <Image
      className="ProXtraLinks__linkIcon"
      width="24pxpx"
      height="26px"
      src={getImageURL('pro-extra-perk.svg')}
      alt="pro-extra-perk"
    />
    <span className="ProXtraLinks__linkLabel">PERKS</span>
  </a>
);

const PricingLink = () => (
  <a
    href={getHostCURL('/b2b/account/view/proXtraPricing')}
    rel=" noreferrer"
    onClick={() => handleFooterAnalytics(analytics.PREFIX, analytics.Pricing)}
  >
    <Image
      className="ProXtraLinks__linkIcon"
      width="23.92px"
      height="26px"
      src={getImageURL('WelcomeCard/PP_RGB_Orange-Black.svg')}
      alt="PP_RGB_Orange-Black"
    />
    <span className="ProXtraLinks__linkLabel">PRICING</span>
  </a>
);

const OfferLink = () => (
  <a
    href={getHostCURL('/SpecialBuy/ProSpecialBuyOfTheWeek')}
    rel=" noreferrer"
    onClick={() => handleFooterAnalytics(analytics.PREFIX, analytics.Offer)}
  >
    <Image
      className="ProXtraLinks__linkIcon"
      width="25px"
      height="26px"
      src={getImageURL('exclusive-offers.svg')}
      alt="exclusive-offers"
    />
    <span className="ProXtraLinks__linkLabel">OFFERS</span>
  </a>
);

const RenderThreeFooterLinks = ({ linkList }) => {
  return (
    <div className=" ProXtraLinks__moreBox">
      <div className="col__4-12">
        {linkList.length >= 3 && linkList[0]}
      </div>
      <div className="col__4-12 ProXtraLinks__labelCenter">
        {linkList.length >= 3 && linkList[1]}
      </div>
      <div className="col__4-12 ProXtraLinks__labelRight">
        {linkList.length >= 3 && linkList[2]}
      </div>
    </div>
  );
};

const RenderTwoFooterLinks = ({ linkList }) => {
  return (
    <div className=" ProXtraLinks__moreBox">
      <div className="col__6-12  ProXtraLinks__labelPerkBox">
        {linkList.length >= 2 && linkList[0]}
      </div>
      <div className="col__6-12 ProXtraLinks__labelleft">
        {linkList.length >= 2 && linkList[1]}
      </div>
    </div>
  );
};

const RenderOneFooterLink = ({ linkList }) => {
  return (
    <div className=" ProXtraLinks__moreBox">
      <div className="col__12-12 ProXtraLinks__labelCenter">
        {linkList.length >= 1 && linkList[0]}
      </div>
    </div>
  );
};

const RenderProXtraLinks = ({ showingLink }) => {
  const linkList = [];
  const mapLinkListToRenders = () => {
    switch (linkList.length) {
    case 3: return <RenderThreeFooterLinks linkList={linkList} />;
    case 2: return <RenderTwoFooterLinks linkList={linkList} />;
    case 1: return <RenderOneFooterLink linkList={linkList} />;
    default: return <></>;
    }
  };

  const assembleLinkList = () => {
    if (showingLink.Perks) linkList.push(<PerksLink />);
    if (showingLink.Pricing) linkList.push(<PricingLink />);
    if (showingLink.Offer) linkList.push(<OfferLink />);
  };
  assembleLinkList();
  return mapLinkListToRenders();
};

export const ProXtraLinks = () => {
  const { userData } = useContext(DataContext);
  const { customerInfo } = userData || {};
  const { enrolledInPerksProgram, enrolledInPreferredPricing } = customerInfo || {};
  const showingLink = {
    Perks: true, // enrolledInPerksProgram,
    Pricing: true, // enrolledInPreferredPricing,
    Offer: false,
  };

  return <RenderProXtraLinks showingLink={showingLink} />;
};

export const exportsForTesting = {
  PerksLink,
  PricingLink,
  OfferLink,
  RenderThreeFooterLinks,
  RenderTwoFooterLinks,
  RenderOneFooterLink,
  RenderProXtraLinks,
};